document.addEventListener("DOMContentLoaded", function () {
  const currentPage = window.location.pathname + window.location.search;
  const navItems = document.querySelectorAll(".custom-bottom-nav li");
  let isSelected = false;

  navItems.forEach(function (item) {
    const link = item.querySelector("a");
    if (
      link &&
      (link.getAttribute("href") === currentPage ||
        (link.getAttribute("href") ===
          "https://cultstore.com/pages/orders?page=0" &&
          currentPage === "/pages/orders?page=0"))
    ) {
      item.classList.add("selected");
      isSelected = true;
    }
  });

  if (!isSelected) {
    const homeItem = document.querySelector(
      '.custom-bottom-nav li a[href="/"]',
    );
    if (homeItem) {
      homeItem.parentElement.classList.add("selected");
    }
  }

  // Store the initial URL in localStorage if it does not exist
  if (!localStorage.getItem("initialUrl")) {
    localStorage.setItem("initialUrl", window.location.href);
    localStorage.setItem("historyCount", "0");
  }
});

class BackNavigationHandler {
  constructor() {
    this.isWebview = this.detectWebview();
    this.initialUrl = localStorage.getItem("initialUrl"); // Retrieve initial URL from localStorage
    this.setupEventListeners();
    this.neutralizeBackEnabled = false;
    this.initializeHistoryCount();
  }

  initializeHistoryCount() {
    // Initialize or increment history count when navigating to a new page
    if (
      window.location.href !== this.initialUrl &&
      window.location.pathname !== "/"
    ) {
      let count = parseInt(localStorage.getItem("historyCount") || "0");
      count++;
      localStorage.setItem("historyCount", count.toString());
    }
  }

  detectWebview() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS WebView Detection
    const isIOS = /iPhone|iPod|iPad/.test(userAgent);
    const isSafari =
      /Safari/.test(userAgent) || /CriOS|FxiOS|EdgiOS/.test(userAgent); // Exclude Chrome, Firefox, Edge
    const isIOSWebView =
      isIOS &&
      !isSafari &&
      (navigator.standalone === false || /AppleWebKit/.test(userAgent));

    // Android WebView Detection
    const isAndroid = /Android/.test(userAgent);
    const isAndroidWebView =
      (isAndroid && /wv/.test(userAgent)) ||
      (isAndroid &&
        /Version\/\d+\.\d+/.test(userAgent) &&
        !/Chrome/.test(userAgent));

    // React Native WebView Detection
    const isReactNativeWebView = !!window.ReactNativeWebView;
    console.log(
      "isIOSWebView",
      isIOSWebView,
      "isAndroidWebView",
      isAndroidWebView,
      "isReactNativeWebView",
      isReactNativeWebView,
    );

    return isIOSWebView || isAndroidWebView || isReactNativeWebView;
  }

  setupEventListeners() {
    // Listen for browser back/forward navigation
    window.addEventListener("popstate", (event) => {
      if (!this.neutralizeBackEnabled) {
        this.handleBackNavigation();
      }
    });

    // Listen for hardware back button on Android
    document.addEventListener("backbutton", (event) => {
      event.preventDefault();
      this.handleBackNavigation();
    });

    // Listen for messages from native app (based on BackNavigationButton.tsx lines 48-56)
    document.addEventListener("message", (event) => {
      console.log(event);
      if (
        event.data === "Pop Screen" ||
        event.nativeEvent.data === "Pop Screen"
      ) {
        this.handleBackNavigation();
      }
      if (
        event.data === "checkout_complete" ||
        event.nativeEvent?.data === "checkout_complete"
      ) {
        console.log(event.data);
        fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error("Failed to clear the cart");
            }
          })
          .then((data) => {
            console.log("Cart cleared:", data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        window.location.href = "/pages/orders";
      }
    });
  }

  handleBackNavigation() {
    if (window.location.search.includes("utm_source=csredirect")) {
      window.location.href = "/";
      return;
    }
    // If URL contains utm_source=redirect, always go to home page on back navigation
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("utm_source") === "csredirect") {
      window.location.replace("/");
      return;
    }

    let cartDrawer = document.querySelector("cart-drawer");
    let checkMenuDrawer = document.querySelector("body");
    
    if (
      cartDrawer.getAttribute("aria-hidden") === "false" ||
      checkMenuDrawer.classList.contains("reveal-mobile-nav--revealed")
    ) {
      checkMenuDrawer.classList.remove(
        "enable-mobile-nav-transition",
        "reveal-mobile-nav",
        "reveal-mobile-nav--revealed",
      );
      cartDrawer.close();
      return;
    }
    
    let historyCount = parseInt(localStorage.getItem("historyCount") || "0");
    
    if (window.location.pathname === "/") {
      // Close the webview instead of refreshing the page
      this.closeWebview();
    } else if (window.location.origin !== this.initialUrl && historyCount < 2) {
      window.location.href = "/";
      localStorage.setItem("historyCount", "1");
    } else if (historyCount > 1 && window.history.length > 1) {
      // Use a timeout to detect if history.back() fails
      const fallbackTimer = setTimeout(() => {
        window.location.href = "/";
      }, 300);
      
      // Listen for successful navigation
      const handleSuccessfulBack = () => {
        clearTimeout(fallbackTimer);
        historyCount--;
        localStorage.setItem("historyCount", historyCount.toString());
      };
      
      window.addEventListener("popstate", handleSuccessfulBack, { once: true });
      window.history.back();
    } else {
      // Fallback to home page when history is too shallow
      window.location.href = "/";
      localStorage.setItem("historyCount", "1");
    }
  }

  closeWebview() {
    // Clear the initial URL before closing the webview
    localStorage.removeItem("initialUrl");
    localStorage.removeItem("historyCount");
    window.postMessage("CLOSE_WEBVIEW", "*");
    try {
      if (typeof window?.ReactNativeWebView !== "undefined") {
        window.ReactNativeWebView.postMessage("CLOSE_WEBVIEW");
      } else if (typeof window?.opener !== "undefined") {
        window.opener.postMessage("CLOSE_WEBVIEW", "*");
      }
    } catch (ex) {
      console.error("Error closing webview:", ex);
      window.location.href = "/";
    }
  }

  // Based on CultsportPLPV3Widget.tsx (lines 219-230)
  neutralizeBack(callback) {
    this.neutralizeBackEnabled = true;
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      callback();
      window.history.pushState(null, "", window.location.href);
    };
  }

  revivalBack() {
    this.neutralizeBackEnabled = false;
    window.onpopstate = null;
    window.history.go(-1);
    let historyCount = parseInt(localStorage.getItem("historyCount") || "0");
    historyCount--;
    localStorage.setItem("historyCount", historyCount.toString());
  }
}

// Initialize the handler
const backNavigation = new BackNavigationHandler();

function handleBackNavigation() {
  backNavigation.handleBackNavigation();
}
